import { FC, ReactNode } from 'react'

import { ReactComponent as SuccessIcon } from 'assets/success.svg'

import s from './s.module.scss'

type Props = {
  children: ReactNode
}
const Success: FC<Props> = ({ children }) => {
  return (
    <>
      <SuccessIcon className={s.successIcon} />
      <div className={s.decorLeft} />
      <div className={s.decorRight} />
      <div className={s.content}>
        <h1>
          You successfully <br /> claimed rewards
        </h1>
        <span>Stake your rewards to increase profit</span>
        {children}
      </div>
    </>
  )
}

export default Success
